import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import {
  editForm,
  confirmForm,
  EVENT_FORM,
  deleteDate,
} from '../Actions/actions';
import { formName, PERMISSION_MANAGE_SETTINGS } from '../Constants/constants';
import Event from '../Components/Event/Event';
import { dateHelpers } from '@jauntin/utilities';
import { getTotalEventAttendees } from '../Helpers/StoreSelectors';
const { pickedToBlockedDays, pickedDaysToNumberedArray } = dateHelpers;

const formValues = formValueSelector(formName);

const mapStateToProps = (state) => {
  const eventFrequency = formValues(state, 'eventFrequencyField');
  const blockedDays =
    eventFrequency === 'weekly'
      ? pickedToBlockedDays(formValues(state, 'daysOfWeekField'))
      : [];

  return {
    enabled: state.formPage.aboutEvent.enabled,
    confirmed: state.formPage.aboutEvent.confirmed,

    blockedDays,
    showDaysOfWeekField: eventFrequency === 'weekly',
    showListOfDates: eventFrequency !== 'continuous',
    showDatePicker:
      eventFrequency === 'continuous' ||
      (eventFrequency === 'weekly' && blockedDays.length < 7),
    showCustomDatePicker: eventFrequency === 'custom',

    eventName: formValues(state, 'eventName'),
    eventDates: formValues(state, 'eventDates'),
    eventFrequency,
    daysOfWeek: pickedDaysToNumberedArray(formValues(state, 'daysOfWeekField')),
    eventTotalGuests: getTotalEventAttendees(state),
    eventDailyGuests: formValues(state, 'eventDailyGuests'),
    eventPerformersCount: formValues(state, 'eventPerformersCount'),
    eventGoods: formValues(state, 'eventGoods'),
    eventFood: formValues(state, 'eventFood'),
    eventExhibition: formValues(state, 'eventExhibition'),
    valid: state.formPage.aboutEvent.valid,
    mobileDisplay: state.formPage.summary.mobileDisplay,
    price: state.formPage.priceValues.basicCoverageAmount,
    venueUtcOffset: state.formPage.venue.selectedPlaceUtcOffset || 0,
    performersList: formValues(state, 'performersList'),
    goodsVendorsList: formValues(state, 'goodsVendorsList'),
    foodVendorsList: formValues(state, 'foodVendorsList'),
    exhibitorsList: formValues(state, 'exhibitorsList'),
    performersFrequency: formValues(state, 'performersFrequency'),
    goodsVendorsFrequency: formValues(state, 'goodsVendorsFrequency'),
    foodVendorsFrequency: formValues(state, 'foodVendorsFrequency'),
    exhibitorsFrequency: formValues(state, 'exhibitorsFrequency'),
    canManageSettings:
      state.formPage.loggedInUser?.permissions?.includes(
        PERMISSION_MANAGE_SETTINGS,
      ) || false,
  };
};

const mapDispatchToProps = (dispatch) => ({
  edit: () => dispatch(editForm(EVENT_FORM)),
  confirm: () => dispatch(confirmForm(EVENT_FORM)),
  deleteDate: (date) => dispatch(deleteDate(date)),
});

const EventContainer = connect(mapStateToProps, mapDispatchToProps)(Event);

export default EventContainer;
